/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ScaniaImportXmlRequest
 */
export interface ScaniaImportXmlRequest {
  /**
   *
   * @type {string}
   * @memberof ScaniaImportXmlRequest
   */
  sessionId: string
  /**
   *
   * @type {string}
   * @memberof ScaniaImportXmlRequest
   */
  xmlDataBase64: string
}

/**
 * Check if a given object implements the ScaniaImportXmlRequest interface.
 */
export function instanceOfScaniaImportXmlRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'sessionId' in value
  isInstance = isInstance && 'xmlDataBase64' in value

  return isInstance
}

export function ScaniaImportXmlRequestFromJSON(
  json: any,
): ScaniaImportXmlRequest {
  return ScaniaImportXmlRequestFromJSONTyped(json, false)
}

export function ScaniaImportXmlRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ScaniaImportXmlRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    sessionId: json['session_id'],
    xmlDataBase64: json['xml_data_base64'],
  }
}

export function ScaniaImportXmlRequestToJSON(
  value?: ScaniaImportXmlRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    session_id: value.sessionId,
    xml_data_base64: value.xmlDataBase64,
  }
}
